module.exports = __webpack_public_path__ + "img/default-user-photo.9cb0dc6a.png";